import { cva } from "class-variance-authority";
export const formHeaderStyles = cva([
    "text-left",
    "mb-8",
    "flex",
    "flex-col",
    "gap-4",
    "w-full",
    "md:mb-0",
    "md:gap-3",
    "md:max-w-[396px]",
    "lg:max-w-[476px]",
], {
    variants: {},
    defaultVariants: {},
});
//# sourceMappingURL=form-header.styles.js.map